import { useMutation } from 'react-query'

import { api } from '../../../api'
import { type ResearcherPersistence } from '../../../../types/persistence/researcher-persistence'

const createResearcher = async (newResearcher: ResearcherPersistence) => {
  const response = await api.post('/researchers', newResearcher)
  return response.data
}

export const useResearcherCreateMutation = () => {
  return useMutation('remove-researcher', {
    mutationFn: (newResearcher: ResearcherPersistence) => {
      return createResearcher(newResearcher)
    },
  })
}
